'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/lib/auth';

/**
 * Mounted at the top of the public landing page. The moment we detect a
 * stored session bearer token, we bounce the user into /app — they've
 * already signed in, so keeping them on marketing pages is just friction.
 * Returns null; the redirect runs in a useEffect so SSR output is stable.
 */
export function LandingAuthRedirect() {
  const router = useRouter();
  const { authed, ready, bypass } = useAuth();

  useEffect(() => {
    if (ready && authed && !bypass) {
      router.replace('/app');
    }
  }, [ready, authed, bypass, router]);

  return null;
}
